<template>
    <tr>
        <td :title="getUpdatedDateString">
            <small>{{ getUpdatedDateString }}</small>
        </td>
        <td :title="getGroupString">
            <small class="ellipsis">{{ getGroupString }}</small>
        </td>
        <td :title="getColumnString">
            <small class="ellipsis">{{ getColumnString }}</small>
        </td>
        <td :title="getStartedDateString">
            <small>{{ getStartedDateString }}</small>
        </td>
        <td :title="getProgramString">
            <small class="ellipsis">{{ getProgramString }}</small>
        </td>
        <td :title="getStatusString">
            <small class="ellipsis">{{ getStatusString }}</small>
        </td>
        <td :title="getMemoString">
            <small class="ellipsis">{{ getMemoString }}</small>
        </td>
        <td :title="getModifierString">
            <small class="ellipsis">{{ getModifierString }}</small>
        </td>
    </tr>
</template>

<script>
import moment from '../../../../../../../../../util/MPMoment'

export default {
    props: {
        history: Object
    },
    data() {
        return {}
    },
    watch: {},
    computed: {
        reservation: function () {
            return this.history.body
        },
        getUpdatedDateString: function () {
            return moment(this.history.createdAt).format(this.$t('common.date_format_YYYY_MM_DD_HH_mm'))
        },
        getGroupString: function () {
            return this.reservation.groupTitle ?? '-'
        },
        getColumnString: function () {
            return this.reservation.columnTitle ?? '-'
        },
        getStartedDateString: function () {
            return moment(this.reservation.startedAt).format(this.$t('common.date_format_YYYY_MM_DD_HH_mm'))
        },
        getProgramString: function () {
            return this.reservation.programTitle ?? '-'
        },
        getStatusString: function () {
            return this.reservation.statusTitle ?? '-'
        },
        getMemoString: function () {
            return this.reservation.note ?? '-'
        },
        getModifierString: function () {
            let type = this.history.writerType
            if (type >= 3000) {
                return '애프터닥'
            } else if (type == 1000) {
                return '고객'
            } else {
                return this.history.writerID?.realName ?? '-'
            }
        }
    }
}
</script>
